var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-scroll",on:{"scroll":_vm.onScroll}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-scroll.vue